<template>
  <div class="Login">
  </div>
</template>

<script>
import controllerFrame from '../frames/controller'
export default {
  computed: {
    items() {
      return this.$store.getters['members/$items']
    },
    count() {
      return this.$store.getters['members/$count']
    }
  },
  watch: {
    items(newItems) {
      newItems.forEach(item => {
        if (item.timestamp && item.timestamp.toMillis() < Date.now() - 60 * 1000 * 60) {
          this.logout(item.key)
        }
      })
    }
  },
  methods: {
    logout(key) {
      return this.$store.dispatch('members/$remove', key)
    }
  }
}
</script>

<style scoped>

</style>
